import React from 'react';
import { Loading } from 'react-admin';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { CssBaseline, Theme, ThemeProvider } from '@material-ui/core';

import { RbacProvider } from '@blackbox-vision/ra-rbac';

type Props = {
  locale: any;
  theme: Theme;
  canActivate: any;
};

// Proveedores de base. El tema de MUI sigue vivo porque quedan dos superficies
// que lo usan: la pantalla de INGRESO (con su flujo de dos fases y el segundo
// factor, que no se tocó) y el cajón de edición del libro en la ficha del
// inversor, donde vive la validación del dinero. La consola en sí no depende de
// MUI: su piel es console.css.
//
// `MenuItemsProvider` se retiró junto con el menú lateral de react-admin: la
// navegación de la consola es la cabecera (console/shell).
let AppProvider: React.FC<Props> = ({ theme, locale, children, canActivate }) => {
  return (
    <RbacProvider canActivate={canActivate}>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
          <CssBaseline />
          <React.Suspense fallback={<Loading />}>{children}</React.Suspense>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </RbacProvider>
  );
};

AppProvider.displayName = 'AppProvider';

export default AppProvider;
